module.exports = __webpack_public_path__ + "static/media/CallIconForCallbacks2.45d71150.svg";